import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import BackgroundImage from 'components/Toolbar/Shared/BackgroundImage';
import { imagesForAssetsPanel } from 'containers/Documents/selectors';
import { showModal } from 'containers/ModalManager/actions';
import { documentIdsAreBeingUploaded } from 'containers/Project/selectors';

const mapStateToProps = createStructuredSelector({
  documentIdsAreBeingUploaded,
  images: imagesForAssetsPanel,
});

const mapDispatchToProps = {
  showModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundImage);
